<template>
  <v-navigation-drawer id="appDrawer" v-model="drawer" :rail="mini" width="280">
    <a href="/" class="title-link">
      <v-toolbar color="white" flat class="drawer-title">
        <div class="drawer-brand">
          <img src="@/assets/outil_logo.png" height="40" alt="logo" />
          <div class="app-title">
            <p class="text-body-small mb-0 text-primary text-uppercase app-caption font-weight-bold">
              Logiciel d'estimation
            </p>
            <p class="font-weight-bold mb-0 text-primary app-name">L'Outil</p>
          </div>
        </div>
      </v-toolbar>
    </a>
    <div class="drawer-menu--scroll">
      <v-list>
        <template v-for="(item, i) in menus">
          <!--group with subitems-->
          <v-list-group v-if="item.items" :key="`group-${item.name}`" :prepend-icon="item.icon">
            <template #activator="{ props }">
              <v-list-item v-bind="props" :title="item.title"></v-list-item>
            </template>
            <template v-for="subItem in item.items">
              <!--sub group-->
              <v-list-group v-if="subItem.items" :key="`sub-group-${subItem.name}`" subgroup>
                <template #activator="{ props }">
                  <v-list-item v-bind="props" :title="subItem.title"></v-list-item>
                </template>
                <v-list-item
                  v-for="(grand, i) in subItem.children"
                  :key="i"
                  :to="genChildTarget(item, grand)"
                  :href="grand.href"
                  :title="grand.title"
                ></v-list-item>
              </v-list-group>
              <!--child item-->
              <v-list-item
                v-else
                :key="`sub-item-${subItem.name}`"
                :to="genChildTarget(item, subItem)"
                :href="subItem.href"
                :disabled="subItem.disabled"
                :target="subItem.target"
                :title="subItem.title"
              >
                <template v-if="subItem.action" #append>
                  <v-icon :class="[subItem.actionClass || 'success--text']">{{ subItem.action }}</v-icon>
                </template>
              </v-list-item>
            </template>
          </v-list-group>
          <v-list-subheader v-else-if="item.header" :key="`header-${i}`"></v-list-subheader>
          <v-divider v-else-if="item.divider" :key="`divider-${i}`"></v-divider>
          <!--top-level link-->
          <v-list-item
            v-else
            :to="!item.href ? { name: item.name } : '/'"
            :href="item.href"
            :active="item.active"
            :disabled="item.disabled"
            :target="item.target"
            rel="noopener"
            :key="`item-${item.name}`"
            :prepend-icon="item.icon"
            :title="item.title"
          >
            <template v-if="item.subAction" #append>
              <v-icon class="text-success">{{ item.subAction }}</v-icon>
            </template>
          </v-list-item>
        </template>
      </v-list>
      <Help></Help>
    </div>
  </v-navigation-drawer>
</template>
<script>
import menu from '@/menu/menu';
import menuAdmin from '@/menu/menuAdmin';
import Help from '@/components/Help';

export default {
  name: 'app-drawer',
  components: {
    Help,
  },
  props: {
    expanded: {
      type: Boolean,
      default: true,
    },
  },
  data: () => ({
    mini: false,
    drawer: true,
  }),
  computed: {
    computeGroupActive() {
      return true;
    },
    menus() {
      const items = this.$store.getters['user/isAdmin'] ? menuAdmin : menu;

      return items.map(item => {
        if (!item.name && item.href !== '/') {
          return item;
        }

        const path = item.href === '/' ? '/' : this.$router.resolve({ name: item.name }).path;
        const active = this.$route.path === path || (path !== '/' && this.$route.path.startsWith(`${path}/`));

        return { ...item, active };
      });
    },
  },
  created() {
    this.$bus.on('APP_DRAWER_TOGGLED', this.toggleDrawer);
  },
  beforeUnmount() {
    this.$bus.off('APP_DRAWER_TOGGLED', this.toggleDrawer);
  },
  methods: {
    toggleDrawer() {
      this.drawer = !this.drawer;
    },
    genChildTarget(item, subItem) {
      if (subItem.href) {
        return;
      }
      if (subItem.component) {
        return {
          name: subItem.component,
        };
      }
      return { name: `${item.group}/${subItem.name}` };
    },
  },
};
</script>

<style lang="stylus" scoped>
//  @import '../../node_modules/vuetify/src/stylus/settings/_elevations.styl';
#appDrawer {
  overflow: hidden;

  .app-title {
    font-family: 'Open Sans', sans-serif;
    position:relative;
    top:7px;

    .app-caption {
      font-size: 12px
      line-height:0
    }

    .app-name {
      font-size: 30px;
      margin:0;
    }
  }

  .drawer-menu--scroll {
    height: calc(100vh - 64px);
    overflow: auto;
  }

  .help-menu {
    position: absolute;
    bottom: 0;
    padding: 10px;
    height: calc(100% - 400px);
    overflow-y: scroll;
  }

  .title-link {
    display: block;
    text-decoration: none;
    color: #fff;
  }

  .drawer-title :deep(.v-toolbar__content) {
    justify-content: center;
    padding: 0 16px;
  }

  .drawer-brand {
    align-items: center;
    display: flex;
    flex: 0 1 auto;
    gap: 16px;
    min-width: 0;
  }

  :deep(.v-list-item--link:hover) {
    background-color: #f5f5f5;
  }

  :deep(.v-list-item--link > .v-list-item__overlay) {
    opacity: 0;
    transition: none;
  }

  :deep(.v-list-item--active) {
    color: unquote("rgb(var(--v-theme-primary))");

    .v-list-item-title {
      font-weight: bold;
    }

    .v-list-item__overlay {
      opacity: 0;
    }
  }
}
</style>
